__turbopack_context__.v({
  "advantages": "Advantages-module__Q1M-4W__advantages",
  "card": "Advantages-module__Q1M-4W__card",
  "cardBorder": "Advantages-module__Q1M-4W__cardBorder",
  "cardDescription": "Advantages-module__Q1M-4W__cardDescription",
  "cardTitle": "Advantages-module__Q1M-4W__cardTitle",
  "container": "Advantages-module__Q1M-4W__container",
  "glowOrb1": "Advantages-module__Q1M-4W__glowOrb1",
  "glowOrb2": "Advantages-module__Q1M-4W__glowOrb2",
  "grid": "Advantages-module__Q1M-4W__grid",
  "icon": "Advantages-module__Q1M-4W__icon",
  "iconWrap": "Advantages-module__Q1M-4W__iconWrap",
  "sectionHeaderDark": "Advantages-module__Q1M-4W__sectionHeaderDark",
  "sectionLabel": "Advantages-module__Q1M-4W__sectionLabel",
  "sectionSubtitle": "Advantages-module__Q1M-4W__sectionSubtitle",
  "sectionTitle": "Advantages-module__Q1M-4W__sectionTitle",
});
